import { render, staticRenderFns } from "./EditEmployeeHeader.vue?vue&type=template&id=708183d4&scoped=true&"
import script from "./EditEmployeeHeader.vue?vue&type=script&lang=ts&"
export * from "./EditEmployeeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EditEmployeeHeader.vue?vue&type=style&index=0&id=708183d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708183d4",
  null
  
)

export default component.exports